module.exports = __webpack_public_path__ + "static/media/slide1.e5119c32.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DesignersPen/slide1.gif
// module id = 176
// module chunks = 0